module.exports = __webpack_public_path__ + "static/media/Features.268e5483.webp";